var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1090,
    height: 1090,
    viewBox: "0 0 1090 1090",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    fill: "#504c4c"
  }, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#504c4c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "487c253e-74d2-447d-8bd2-e74d27ad88b2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "0059a199-e000-4290-8db5-a165ca9664db"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.94 0 0 7.94 572.96 616.81)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.45 4.27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "#636767",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-152.83, -504.93)",
    d: "M 152.835 503.771 C 152.2823699511743 503.77020758078845 151.80618979371076 504.1600202668986 151.6978220658783 504.70192158112263 C 151.58945433804587 505.2438228953467 151.8791014497316 505.7867833205219 152.3895356934381 505.99857916950174 C 152.89996993714462 506.21037501848156 153.48893176238406 506.0319781546498 153.79605039423942 505.57254508579143 C 154.10316902609475 505.11311201693303 154.04284958324118 504.50068811355544 153.65200000000002 504.11 C 153.43537776029828 503.89315735594784 153.14150591914313 503.7712203251625 152.835 503.771 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 5.51 4.27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "#636767",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.09, -504.93)",
    d: "M 148.09 503.771 C 147.5373699511743 503.77020758078845 147.06118979371075 504.1600202668986 146.9528220658783 504.70192158112263 C 146.84445433804586 505.2438228953467 147.1341014497316 505.7867833205219 147.6445356934381 505.99857916950174 C 148.1549699371446 506.21037501848156 148.74393176238405 506.0319781546498 149.0510503942394 505.57254508579143 C 149.35816902609474 505.11311201693303 149.29784958324117 504.50068811355544 148.907 504.11 C 148.69037776029828 503.89315735594784 148.39650591914312 503.7712203251625 148.09 503.771 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.42 4.27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "#636767",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-143.34, -504.93)",
    d: "M 143.345 503.771 C 142.7923699511743 503.77020758078845 142.31618979371075 504.1600202668986 142.2078220658783 504.70192158112263 C 142.09945433804586 505.2438228953467 142.38910144973158 505.7867833205219 142.89953569343808 505.99857916950174 C 143.4099699371446 506.21037501848156 143.99893176238405 506.0319781546498 144.3060503942394 505.57254508579143 C 144.61316902609474 505.11311201693303 144.55284958324117 504.50068811355544 144.162 504.11 C 143.94537776029827 503.89315735594784 143.65150591914312 503.7712203251625 143.345 503.771 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.88 4.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-137.88, -505.01)",
    d: "M 137.877 503.772 L 137.877 506.24399999999997",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.51 4.35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-134.71, -505.01)",
    d: "M 134.713 503.772 L 134.713 506.24399999999997",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -10.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-149.55, -496.46)",
    d: "M 131.843 502.121 L 137.785 490.79499999999996 L 161.308 490.79499999999996 L 167.25 502.121",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 12.45)",
    id: "Ellipse_1826"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#636767",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3.654
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 3.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-149.8, -507.04)",
    d: "M 155.3 515.529 L 167.234 515.529 C 167.83807712408498 515.5062039674779 168.31056518635168 515.0002219499465 168.292 514.396 L 168.292 499.674 C 168.30944413099112 499.07054745915576 167.83727398160877 498.5657984620372 167.234 498.543 L 132.354 498.543 C 131.75191243307816 498.5673975981601 131.28152403960522 499.07167179059405 131.299 499.674 L 131.299 514.4",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 3.96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#636767",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-149.8, -507.04)",
    d: "M 144.291 515.529 L 132.355 515.529 C 131.75371338066353 515.5046040912424 131.28364015386262 515.0015589035095 131.3 514.4 L 131.3 499.674 C 131.28252403960522 499.07167179059405 131.75291243307817 498.5673975981601 132.35500000000002 498.543 L 167.235 498.543 C 167.83827398160878 498.5657984620372 168.31044413099113 499.07054745915576 168.293 499.674 L 168.293 514.4",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.89 0 0 6.89 572.86 681.79)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.5 54.6)",
    style: {},
    id: "Distributor"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "ProximaNova-Semibold, Proxima Nova",
    fontSize: 18,
    fontStyle: "normal",
    fontWeight: 600,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#636767",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 -46.77)",
    id: "Line_48"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0,
    y1: 11.5,
    x2: 0,
    y2: -11.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 26.23)",
    id: "Line_49"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0,
    y1: 11.5,
    x2: 0,
    y2: -11.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 39.5 -9.77)",
    id: "Line_50"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0,
    y1: 11.5,
    x2: 0,
    y2: -11.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 -1 0 -39.5 -9.77)",
    id: "Line_51"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x1: 0,
    y1: 11.5,
    x2: 0,
    y2: -11.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 -61.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 -61.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 40.73)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5 40.73)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.5 -9.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.5 -9.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 53.5 -9.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 53.5 -9.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "#636767",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorGray);
export default __webpack_public_path__ + "static/media/distributor_gray.81f4b4612a8d61292949846a46208553.svg";
export { ForwardRef as ReactComponent };